// import router from '@/utils/router'
// import { constantRouterMap } from '@/utils/router'
const permission = {
  state: {
    routers: [],
    // routers: constantRouterMap !== null ? constantRouterMap : [],
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      // -合併本機與遠端route 目錄
      /*
      const constantRouterPath = constantRouterMap.map(item => {
        return item.path
      })
      routers.forEach(router => {
        const path = router.path
        const constantIndex = constantRouterPath.indexOf(path)
        if (constantIndex !== -1) {
          if (constantRouterMap[constantIndex].children) {
            constantRouterMap[constantIndex].children = constantRouterMap[constantIndex].children.concat(router.children)
          } else {
            constantRouterMap[constantIndex].children = router.children
          }
        } else {
          // 這目錄在constant內不存在, 直接加入
          constantRouterMap.push(router)
        }
      })
      state.routers = constantRouterMap
      router.addRoutes(constantRouterMap)
      router.options.routes = constantRouterMap
      */
    }
  },
  actions: {
    AddRoutes ({ commit }, data) {
      return new Promise(resolve => {
        // 先忽略使用者權限 直接加入 data 為 []
        commit('SET_ROUTERS', data)
        resolve()
      })
    }
  }
}
export default permission
